module.exports = __webpack_public_path__ + "img/ios-copy-guide.6228be20.png";